import { createModel } from '@/store/tools';

const model = {
    namespace: 'black',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getBlackList': T('getBlackList'),
            'getAccountTypeEnum': T('getAccountTypeEnum'),
        },
        actions: {
            'getBlackList': A('getBlackList'),
            'getAccountTypeEnum': A('getAccountTypeEnum', { enumName: 'BlockLogAccountTypeEnum' }),
        },
        sagas: {
            'getBlackList': S('getBlackList', '/?cmd=com.xqxc.api.pig.mis.biz.account.BlockLogMisService.list'),
            'getAccountTypeEnum': S('getAccountTypeEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
        },
        reducers: {
            'getBlackList': R('getBlackList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getAccountTypeEnum': R('getAccountTypeEnum', []),
        }
    })
};
export default createModel(model);